import createIcon from '../../createIcon';

/**
 * @component @name SwitchAccount
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA2SDJWMjBDMiAyMS4xIDIuOSAyMiA0IDIySDE4VjIwSDRWNlpNMjAgMkg4QzYuOSAyIDYgMi45IDYgNFYxNkM2IDE3LjEgNi45IDE4IDggMThIMjBDMjEuMSAxOCAyMiAxNy4xIDIyIDE2VjRDMjIgMi45IDIxLjEgMiAyMCAyWk0xNCA0QzE1LjY2IDQgMTcgNS4zNCAxNyA3QzE3IDguNjYgMTUuNjYgMTAgMTQgMTBDMTIuMzQgMTAgMTEgOC42NiAxMSA3QzExIDUuMzQgMTIuMzQgNCAxNCA0Wk0yMCAxNkg4VjE0LjVDOCAxMi41MSAxMiAxMS41IDE0IDExLjVDMTYgMTEuNSAyMCAxMi41MSAyMCAxNC41VjE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwitchAccount = createIcon('SwitchAccount', [
  [
    'path',
    {
      d: 'M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM14 4C15.66 4 17 5.34 17 7C17 8.66 15.66 10 14 10C12.34 10 11 8.66 11 7C11 5.34 12.34 4 14 4ZM20 16H8V14.5C8 12.51 12 11.5 14 11.5C16 11.5 20 12.51 20 14.5V16Z',
      key: '1wdjxl',
    },
  ],
]);

export default SwitchAccount;
